module.exports = require('./helpers/bundle-url').getBundleURL('aXMci') + "marker-shadow.1d701568.png" + "?" + Date.now();